import { useSyncExternalStore } from "react";
import {
  getImpersonation,
  subscribeImpersonation,
  type ImpersonationState,
} from "@/lib/impersonation";

export function useImpersonation(): ImpersonationState | null {
  return useSyncExternalStore(
    subscribeImpersonation,
    getImpersonation,
    () => null,
  );
}
